export default "__VITE_ASSET__B$NdfAFC__"